import React from 'react';
// Utils
import { validArray } from 'utils';
// Elements
import { DrawerContent, DrawerHeader, DrawerNavItem } from 'elements/Drawer';

function AppLinks({ userRoles }:{ userRoles:string[] }) {
  return (
    <>
      <DrawerHeader>
        <h4 className="display6">App Links</h4>
      </DrawerHeader>
      <DrawerContent>
        {validArray(userRoles) && (
          <nav>
            <>
              {userRoles.includes('PLANNING ADMIN') && (
                <DrawerNavItem
                  href="/user-admin"
                  icon="User"
                  iconBackground="tertiary"
                  label="User Admin"
                />
              )}
              {(userRoles.includes('PLANNING') || userRoles.includes('PLANNING ADMIN') || userRoles.includes('WAREHOUSE')) && (
                <DrawerNavItem
                  href="/dispatcher"
                  icon="TruckCheck"
                  iconBackground="tertiary"
                  label="Sales Order Processing"
                />
              )}
              {(userRoles.includes('PLANNING ADMIN') || userRoles.includes('MASTER DATA') || userRoles.includes('PLANNING') || userRoles.includes('WAREHOUSE')) && (
                <DrawerNavItem
                  href="/event-log"
                  icon="EventLog"
                  iconBackground="tertiary"
                  label="Event Log"
                />
              )}
              {(userRoles.includes('PLANNING')) && (
                <DrawerNavItem
                  href="/pack-site"
                  icon="PackSite"
                  iconBackground="tertiary"
                  label="Site Order Fulfilment Tool"
                  />
              )}
              {userRoles.includes('PLANNING') && (
                <DrawerNavItem
                  href="/sales-order"
                  icon="EventLog"
                  iconBackground="tertiary"
                  label="View Sales Orders"
                />
              )}
            </>
          </nav>
        )}
      </DrawerContent>
    </>
  );
}

export default AppLinks;
